import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
    constructor() { }

    isNullOrWhiteSpace(input:string): boolean {
        return (input === null || input === undefined || input.trim() === '');
    }

    //Returns a number in format YYYYMMDD
    dateAsNumber(dateToFormat: Date): number {
        const dateToString = moment(dateToFormat).format().split('T')[0];
        const deleteHyphens = dateToString.replace(/\-/g,'');
        return Number(deleteHyphens);
    }

    isUsersdeptOrChildDept(userDept: string, targetDept: string): boolean
    {
        if (targetDept.length < userDept.length) return false;
        
        return targetDept.substring(0,userDept.length) === userDept;
    }

    reverseName(name: string): string {
        try {
                const revName = this.reverseString(name);
                const index = revName.indexOf(" ");

                const firstName = this.reverseString(revName.substring(0, index));
                const lastName = this.reverseString(revName.substring(index + 1));

                return `${firstName} ${lastName}`;
            }

            catch
            {
                return name;
            }
    }

    reverseString(input: string): string {
        return input.split("").reverse().join("");
    }
}